import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDBox } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

const OutflowsMoneyFlowsSectionLayout = () => {
  const isMobile = useMobileLayout();
  return (
    <FDBox width={'100%'} paddingY={isMobile ? 2 : 6}>
      <MetaControlField attr={'moneyFlows'} />
    </FDBox>
  );
};

OutflowsMoneyFlowsSectionLayout.defaultProps = {};

OutflowsMoneyFlowsSectionLayout.propTypes = {};

export default OutflowsMoneyFlowsSectionLayout;
